
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import Vue from 'vue';
import Axios from 'axios';

window.Vue = Vue;
window.accounting = require('accounting');

import vSelect from 'vue-select'
Vue.component('v-select', vSelect);

import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { GSDevTools } from "gsap/GSDevTools";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(TextPlugin, ScrollToPlugin, ScrollTrigger, CustomEase, DrawSVGPlugin, GSDevTools, MorphSVGPlugin, SplitText);

window.gsap = gsap;

//import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";

//without this line, PixiPlugin and MotionPathPlugin may get dropped by your bundler (tree shaking)...
//gsap.registerPlugin(PixiPlugin, MotionPathPlugin);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.prototype.$eventHub = new Vue(); // Global event bus

let problemScript = $(".js-skip").children().detach();
const app = new Vue({
    el: '#app',
    data() {
        return {
            trans: null,
            trans_menu: null,
            currentLang: '',
            types: {
                'it' : {
                    'vini' : 'vini',
                    'grappe' : 'grappe',
                    'accessori' : 'accessori',
                    'collezioni' : 'confezioni',
                    'sapori' : 'sapori',
                },
                'en' : {
                    'vini' : 'wines',
                    'grappe' : 'spirits',
                    'accessori' : 'accessories',
                    'collezioni' : 'sets',
                    'sapori' : 'tastings',
                }
            }
        }
    },
    created() {
        axios.get('/api/translations')
        .then(response => {
            this.trans = response.data;
        });
        axios.get('/api/translations/menu')
        .then(response => {
            this.trans_menu = response.data;
        });

        this.currentLang = document.documentElement.lang;
    },
    methods: {
        langRoute(route) {

            let translations = {
                'en' : {
                    '/cassa' : '/checkout',
                    '/carrello' : '/cart',
                },
                'it' : {
                    '/cassa' : '/cassa',
                    '/carrello' : '/carrello',
                }
            };

            return '/' + this.currentLang + translations[this.currentLang][route];
        },
        translateStringMenu(code) {
            if(this.trans_menu == null || typeof this.trans_menu[code] == 'undefined') {
                return code;
            }

            return this.trans[code];
        },
        translateString(code) {
            if(this.trans == null || typeof this.trans[code] == 'undefined') {
                return code;
            }

            return this.trans[code];
        },
        currencyDisplay(val) {
            return accounting.formatMoney(val, "€ ", 2, ".", ",");
        },
        currencyDisplaySimple(val) {
            return accounting.formatMoney(val, "", 2, ".", ",");
        },
        slugifyType(lang, type) {
            return this.types[lang][type];
        },
        formatNumber(value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            });
            return formatter.format(value);
        },
    }
});

$('.js-skip').append(problemScript);
